module.exports = __webpack_public_path__ + "static/media/AppstoreRejects.6d9f445f.svg";